
import {FC, useMemo} from "react";

import {DocumentPlusIcon} from "@heroicons/react/24/outline";
import Loader from "../../components/layouts/loader";
import {withRoles, wrapClick, useUrlState} from "../../utils";
import CreateMeterContractorTestingFacilityContainer from "./cards/update-testing-facility";

type Props = {
  data: any,
  loading: boolean,
  refetch: () => void,
}

const SettingsTestingFacilitiesContainer: FC<Props> = ({ data, loading, refetch }) => {

  const [modal, setModal] = useUrlState("modal");

  const facility = useMemo(() => data?.meterContractor?.testingFacility || null, [data])

  if(loading){
    return (
      <div className="flex-1 w-full min-h-full py-6">
        <Loader text={"Loading Test Facility..."} />
      </div>
    )
  }


  // @ts-ignore
  return (
    <div className="overflow-hidden shadow sm:rounded-md">
      <div className="bg-white px-8 py-5">
        <div className={"flex flex-col"}>
          {
            !Boolean(facility) ? (
              <>
                <div className={"w-full py-16 bg-gray-50 rounded text-gray-600 border-gray-200 border-2 border-dashed grid place-items-center"}>
                  No Testing Facility Provided.
                </div>
              </>
            ) : (
              <>
                <div className={"mt-2"}>
                  <div className="flex min-w-0 gap-x-4 mb-4">
                    <div className="min-w-0 flex-auto">
                      <p className="text-md font-medium leading-6 text-gray-900">
                        {facility.name}
                      </p>
                    </div>
                  </div>

                  <div
                    className="space-y-1"
                    role="group"
                  >
                    <div className="border-2 border-gray-200 border-dashed bg-gray-50 grid grid-cols-3 gap-6 p-6 rounded">
                      <div className={"col-span-2"}>
                        <span className="block text-sm font-light text-gray-700">
                          Residential Address
                        </span>
                        <div className="mt-1 block w-full sm:text-sm">
                          {facility?.address || "N/A"}
                        </div>
                      </div>
                      <div className={"col-span-1"}>
                        <span className="block text-sm font-light text-gray-700">
                          GhanaPost Address
                        </span>
                        <div className="mt-1 block w-full sm:text-sm">
                          {facility?.ghanaPostAddress || "N/A"}
                        </div>
                      </div>
                      <div className={"col-span-2"}>
                        <span className="block text-sm font-light text-gray-700">
                          Contact Person
                        </span>
                        <div className="mt-1 block w-full sm:text-sm">
                          {facility?.contactPerson?.fullName || "N/A"}
                        </div>
                      </div>
                      <div className={"col-span-1"}>
                        <span className="block text-sm font-light text-gray-700">
                          Phone Number
                        </span>
                        <div className="mt-1 block w-full sm:text-sm">
                          {facility?.contactPerson?.phoneNumber || "N/A"}
                        </div>
                      </div>
                      <div className={"col-span-1"}>
                        <span className="block text-sm font-light text-gray-700">
                          Email Address
                        </span>
                        <div className="mt-1 block w-full sm:text-sm">
                          {facility?.contactPerson?.emailAddress || "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )
          }
        </div>
        <div className={"flex-1 flex justify-end mt-4"}>
          {withRoles(["Super"])(
            <button
              type="button"
              onClick={wrapClick(() => setModal("create-testing-facility"))}
              className="ml-3 inline-flex items-center rounded-md border border-transparent bg-primary-600 px-3 py-2 text-sm leading-4 text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
              <DocumentPlusIcon
                className="-ml-0.5 mr-2 h-4 w-4"
                aria-hidden="true"
              />
              {Boolean(facility) ? "Update Facility Details" : "Add Facility Details"}
            </button>
          )}
        </div>
      </div>
      <CreateMeterContractorTestingFacilityContainer
        open={modal === "create-testing-facility"}
        setOpen={(val: boolean) => setModal(val ? "create-testing-facility" : undefined)}
        refetch={refetch}
      />
    </div>
  );



};

export default SettingsTestingFacilitiesContainer;